namespace ui
{

	export type Context = 'default'|'primary'|'success'|'info'|'warning'|'danger';

	export namespace json
	{
		export function Highlight(json: string|object)
		{
				if (typeof json != 'string') {
						json = JSON.stringify(json, undefined, 2);
				}
				json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
				return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
						let cls = 'number';
						if (/^"/.test(match)) {
								if (/:$/.test(match)) {
										cls = 'key';
								} else {
										cls = 'string';
								}
						} else if (/true|false/.test(match)) {
								cls = 'boolean';
						} else if (/null/.test(match)) {
								cls = 'null';
						}
						return '<span class="' + cls + '">' + match + '</span>';
				});
		}
	}

}

function last<T>( array: T[] ): T
{
	const l = array.length;

	return array[l - 1 ];
}
